// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"8405c3e5","867":"5f1a2da4"}[chunkId] + ".chunk.js";
};